import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDrawer } from '../../../shared/drawer';
import { PageBody } from '../../../elements/page-body';

import { Table } from "../../../elements/table";
import { RentingCompaniesForm } from './renting-companies-form';
//import { ResponsablesForm } from './responsables-form';


export const RentingCompanies = () => {
    const { open, close } = useDrawer();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState<string | null>(null);


    const handleNewAction = () => {
        open('common.form-title.new', <RentingCompaniesForm close={handleClose} />);
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };


    return (
        <>

            <PageBody
                newAction={handleNewAction}
                title={'common.label.empresas-renting'}
                newActionTitle={'common.form-title.new'}

            >
                <Table
                    path="/fleet/"
                    deletePath="/fleet/"
                    callBeforeDrawerClosed={handleClose}
                    Form={RentingCompaniesForm}
                    withPagination
                    refresh={refresh}
                    headers={[
                        {
                            key: 'user',
                            subKey: 'email',
                            label: 'common.form-label.email',
                        }, {
                            key: 'user',
                            subKey: 'name',
                            label: 'common.form-label.first_name',
                        }
                    ]}
                />
            </PageBody>
        </>
    );
};